﻿import { playVideo, pauseVideo } from "../../Shared/Video/video";
import { prefersReducedMotion } from "../../Shared/Utilities/userPreferences";
import {
  getRequiredElement,
  getRequiredDatasetAttribute
} from "../../Shared/Utilities/attributes";
import { initializeModal } from "../../Shared/Modal/modal";
import { getPlayer, isVimeoPlayer } from "../../Shared/Utilities/video";

const largeTeasers = document.querySelectorAll<HTMLElement>(
  "[data-large-teaser-video='true']"
);

const getPlayPauseElements = (container: HTMLElement) => {
  const playPauseButton = container.querySelector<HTMLElement>(
    "[data-js-play-pause-button]"
  );

  if (!playPauseButton) {
    return { playPauseButton: null, playButton: null, pauseButton: null };
  }

  return {
    playPauseButton,
    playButton: playPauseButton.querySelector<HTMLElement>(
      "[data-js-symbol-name='play']"
    ),
    pauseButton: playPauseButton.querySelector<HTMLElement>(
      "[data-js-symbol-name='pause']"
    )
  };
};

largeTeasers.forEach(largeTeaser => {
  let isPlaying = false;
  const hasModal = getRequiredDatasetAttribute(
    largeTeaser,
    "hasModal",
    "Modal indicator not found."
  );

  if (hasModal == "true") {
    const modal = getRequiredElement<HTMLElement>(
      largeTeaser,
      "[data-modal]",
      "Modal not found"
    );
    initializeModal(modal);
    const modalIframe = getRequiredElement<HTMLIFrameElement>(
      modal,
      "iframe",
      "Iframe not found in modal"
    );
    const modalPlayer = getPlayer(modalIframe);
    if (!modalPlayer) {
      console.error("Couldn't get a video player");
      return;
    }
    modal.addEventListener("modal:open", () => playVideo(modalPlayer));
    modal.addEventListener("modal:close", () => pauseVideo(modalPlayer));
  }

  const teaserVideoIframe =
    largeTeaser.querySelector<HTMLIFrameElement>("[data-teaser-video]");

  if (teaserVideoIframe) {
    const teaserVideoPlayer = getPlayer(teaserVideoIframe);

    if (!teaserVideoPlayer) {
      console.error("Couldn't get a video player");
      return;
    }

    if (!isVimeoPlayer(teaserVideoPlayer)) {
      console.error("Background videos only support Vimeo");
      return;
    }

    teaserVideoPlayer.on("play", () => (teaserVideoIframe.ariaHidden = "false"));

    if (hasModal == "false") {
      const { playPauseButton, playButton, pauseButton } =
        getPlayPauseElements(largeTeaser);

      if (playPauseButton && playButton && pauseButton) {
        playPauseButton.addEventListener("click", () => {
          playButton.classList.toggle("hidden");
          pauseButton.classList.toggle("hidden");
          isPlaying ? pauseVideo(teaserVideoPlayer) : playVideo(teaserVideoPlayer);
          isPlaying = !isPlaying;
        });
      }
    }

    if (!prefersReducedMotion() || hasModal == "false") {
      const scrolledIntoViewHandler = (entries: IntersectionObserverEntry[]) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            playVideo(teaserVideoPlayer);
            const { playPauseButton, playButton, pauseButton } = getPlayPauseElements(
              entry.target as HTMLElement
            );
            if (playPauseButton && playButton && pauseButton) {
              playButton.classList.toggle("hidden");
              pauseButton.classList.toggle("hidden");
              isPlaying = true;
            }
            intersectionObserver.unobserve(entry.target);
          }
        });
      };

      const intersectionObserver = new IntersectionObserver(scrolledIntoViewHandler, {
        threshold: 0
      });
      intersectionObserver.observe(largeTeaser);
    }
  }
});
